export default function initHeader() {
    jQuery(".handbruger-menu").on('click',function(){
        jQuery('body').toggleClass('open')
    })
    jQuery(".menu ul li i").on('click', function(){
        jQuery(this).closest('li').addClass('open')
        // jQuery(this).addClass('open');
    
        // console.log(this);
        // console.log('jj');
    })


    jQuery(".back-wrap").on('click', function(){
        jQuery(this).closest('li').removeClass('open');
    })
    // jQuery(".menu ul li").on('click', function() {
    //     // Add 'open' class to the closest '.dropdown-wrap' related to the clicked 'li'
    //     jQuery(this).closest('.dropdown-wrap').show();
    //     console.log("hhh")
    // });
    
    // jQuery(".back-wrap").on('click', function() {
    //     // Remove 'open' class from the closest '.dropdown-wrap' when 'back-wrap' is clicked
    //     jQuery(this).closest('.dropdown-wrap').hide();
    //     console.log("hhh-ttt")

    // });

    // document.addEventListener('DOMContentLoaded', function() {
    //     // Select all the li elements
    //     const menuItems = document.querySelectorAll('.menu-main-link li');
        
    //     menuItems.forEach((item) => {
    //         // Add click event listener to each li element
    //         item.addEventListener('click', function() {
    //             const dropdown = item.querySelector('.dropdown-wrap');
    //             const backWrap = dropdown.querySelector('.back-wrap');
                
    //             // Show the dropdown-wrap when li is clicked
    //             dropdown.style.opacity = 1;
    //             dropdown.style.pointerEvents = 'all';
                
    //             // Hide dropdown-wrap when back-wrap is clicked
    //             backWrap.addEventListener('click', function() {
    //                 dropdown.style.opacity = 0;
    //                 dropdown.style.pointerEvents = 'none';
    //             });
    //         });
    //     });
    // });
}

